import {
  LoanEligibilityDto,
  LoanRequestControllerApiFactory,
  BorrowerProfileResponse,
  ConsentControllerApiFactory,
  Configuration,
  LenderSupportingDataControllerApiFactory,
  KoinWorksV2SupportedLocationListResponse,
  FinalApprovalControllerApiFactory,
  FinalApporvalDto,
} from '@ce-openapi/capital-service-ts-axios-client';
import { AxiosPromise } from 'axios';
import { MOKA_CAPITAL_SERVICE } from '../constants';

const conf = new Configuration({
  basePath: MOKA_CAPITAL_SERVICE,
});

export const checkEligibility = (
  lenderCategory: 'TERM_LOAN' | 'INVESTMENTS' | 'FAST_LOAN' | 'KOINWORKS_V2'
): AxiosPromise<LoanEligibilityDto> =>
  LoanRequestControllerApiFactory(conf).checkLenderCategoryEligibilityUsingGET(
    lenderCategory
  ) as AxiosPromise<LoanEligibilityDto>;

export const getConsent = (): AxiosPromise<BorrowerProfileResponse> =>
  ConsentControllerApiFactory(
    conf
  ).getConsentsUsingGET() as AxiosPromise<BorrowerProfileResponse>;

export const getKoinworksSupportedLocations = (
  postalCode: string
): AxiosPromise<KoinWorksV2SupportedLocationListResponse> =>
  LenderSupportingDataControllerApiFactory(
    conf
  ).getKoinWorksSupportedLocationsUsingGET(
    postalCode
  ) as AxiosPromise<KoinWorksV2SupportedLocationListResponse>;

export const submitFinalApprovalForm = (finalApprovalDto: FinalApporvalDto) =>
  FinalApprovalControllerApiFactory(conf).postFinalApprovalUsingPOST(
    finalApprovalDto
  );
